import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Clock, AlertCircle } from "lucide-react";
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const CTASection = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const handleClaimClick = () => {
    // For Android detection
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isUS = true; // In a real app, you would use geolocation or IP-based detection
    
    if (isAndroid && isUS) {
      window.location.href = "https://singingfiles.com/show.php?l=0&u=2389716&id=67673";
    } else {
      setIsDialogOpen(true);
    }
  };

  return (
    <section id="claim-now" className="py-16 md:py-24 bg-background relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute w-96 h-96 bg-primary/10 rounded-full blur-3xl top-0 -right-48"></div>
      <div className="absolute w-80 h-80 bg-secondary/20 rounded-full blur-3xl -bottom-20 -left-20"></div>
      
      <motion.div 
        className="max-w-4xl mx-auto text-center relative z-10 px-4 sm:px-6"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        <div className="inline-flex items-center bg-secondary/30 text-secondary-foreground px-4 py-1 rounded-full text-sm font-medium mb-6">
          <Clock className="mr-2 h-4 w-4" />
          Limited Time Offer
        </div>
        
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-6">
          Ready to Taste the Bold Flavors of Buffalo Wild Wings?
        </h2>
        
        <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Don't miss this exclusive opportunity to try Buffalo Wild Wings samples for free. 
          Available only for Android users in the United States while supplies last.
        </p>
        
        <div className="bg-muted p-4 rounded-lg mb-8 inline-flex items-center text-left max-w-md mx-auto">
          <AlertCircle className="text-primary mr-3 h-5 w-5 flex-shrink-0" />
          <p className="text-sm text-muted-foreground">
            <span className="font-medium">Note:</span> We're seeing high demand. Claim your samples now before they're gone!
          </p>
        </div>
        
        <Button 
          size="lg" 
          onClick={handleClaimClick}
          className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-8 py-6"
        >
          Claim Your Free Samples Now <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
        
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle>Device Not Compatible</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <p className="text-muted-foreground">
                This offer is only available for Android devices in the United States. Please access this page from an Android device to claim your free samples.
              </p>
            </div>
          </DialogContent>
        </Dialog>
        
        <p className="mt-6 text-sm text-muted-foreground">
          By claiming, you agree to our Terms of Service and Privacy Policy.
          No credit card required. While supplies last.
        </p>
      </motion.div>
    </section>
  );
};

export default CTASection;